import { render } from "./widgets-popup.vue?vue&type=template&id=222e3162"
import script from "./widgets-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./widgets-popup.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/card-component/widgets-popup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "222e3162"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('222e3162', __exports__)) {
    api.reload('222e3162', __exports__)
  }
  
  module.hot.accept("./widgets-popup.vue?vue&type=template&id=222e3162", () => {
    api.rerender('222e3162', render)
  })

}


export default __exports__